import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

export class UploadPhotoAdPublisherUseCase extends UseCase {
  #getCurrentUserService
  #httpRepository
  #userNotLoggedInUserError

  constructor({config} = {}) {
    super()

    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config})
    this.#httpRepository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new UploadPhotoAdPublisherUseCase({config})
  }

  @tracer({metric: 'UploadPhotoAdPublisherUseCase#execute'})
  @inlineError
  async execute({image, adId}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: '[UploadPhotoAdPublisherUseCase#execute] User not logged in'
        })
      )
    }

    const [error, uploadPhotoResponseVO] = await this.#httpRepository.uploadPhotoAd({
      adId,
      image,
      userEntity
    })

    if (error) return Promise.reject(error)

    return uploadPhotoResponseVO.toJSON()
  }
}

export const factory = UploadPhotoAdPublisherUseCase.create
